import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void) {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

/** Le navigateur se croit-il en ligne ? (mode avion, réseau coupé) */
export const useOnline = () => useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
